import { connect } from 'react-redux'
import RiderSearch from '../../components/trips/riders/RiderSearch'
import * as riderActions from '../../state/actions/riders'
import { IStoreState } from '../../types'
import { getCurrentOrganization } from '../../state/reducers/organizations'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    query: state.riderSearch.query,
    location: ownProps.location,
    currentOrgIdRequest: state.organizations.currentOrgIdRequest,
    currentOrg: getCurrentOrganization(state),
    currentOrgIdError: state.organizations.currentOrgIdError,
    activeRidersOny: ownProps.activeRidersOnly ? true : false
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onInput: (search: string, orgId: string, isActive?: boolean, isArchived?: boolean) => {
      if (!search || !search.length) {
        return dispatch(riderActions.actionCreators.ridersClearSearch())
      }
      return dispatch(riderActions.searchRidersForTrip({ search, orgId, isActive, isArchived }))
    },
    onClear: () => dispatch(riderActions.actionCreators.ridersClearSearch())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderSearch)



// WEBPACK FOOTER //
// ./src/containers/trips/RiderSearch.ts